import React, { useEffect, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import moment from 'moment';
import EcoEmail, { EmailFieldsType } from 'eco-design/elements/eco-email';
import style from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/i18n';
import { useGlobal } from '@/utils/useGlobal';
import { DialogClose } from '../icons';
import { fetchPost } from 'lowcode/utils/service/FetchClient';
import { baseUrl } from 'lowcode/utils/service/baseUrl';

interface Props {
    onClose: () => void;
    open: boolean;
    multiId: number;
}

const contactListIds = {
    us: '986635575',
    ca: '2097466008',
};

const Dialog: React.FC<Props> = ({ onClose, open, multiId }) => {
    const { t } = useLang('theProduct.C.dialog');
    const { locale } = getLocal();
    const { getSystemTime } = useGlobal();
    const systemTime = getSystemTime();
    const [show, setShow] = useState(false);

    const fields = useMemo(() => {
        const date = moment(systemTime).format('YYYY-MM-DD') as any;
        const NA_Fields: EmailFieldsType[] = [
            { type: 'single', id: '31', value: 1, overwrite: true },
            { type: 'multiple', id: '11150', value: [multiId, 16], overwrite: false },
            { type: 'text', id: '12637', value: date, overwrite: false },
        ];
        switch (locale) {
            case 'us':
                return [{ type: 'single', id: '4423', value: 1, overwrite: true }, ...NA_Fields];
            case 'ca':
                return [{ type: 'single', id: '4424', value: 1, overwrite: true }, ...NA_Fields];
            default:
                return [{ type: 'single', id: '4423', value: 1, overwrite: true }, ...NA_Fields];
        }
    }, [locale, systemTime, multiId]);

    // 邮件
    const termsHtml = useMemo(() => {
        switch (locale) {
            case 'us':
            case 'ca':
                return `I agree to EcoFlow's <a href="https://account.ecoflow.com/agreement/en-${locale}/PrivacyPolicy.html" target="_blank">Privacy Policy</a> and <a href="https://${locale}.ecoflow.com/pages/terms-of-use" target="_blank">Terms of Use</a>.`;
            default:
                return undefined;
        }
    }, [locale]);

    const handleClose = () => {
        setShow(false);
        const timer = setTimeout(() => {
            onClose();
        }, 250);
        return () => clearTimeout(timer);
    };

    useEffect(() => {
        if (open) {
            const timer = setTimeout(() => {
                setShow(true);
            }, 250);
            return () => clearTimeout(timer);
        }
    }, [open]);

    return (
        <>
            {open &&
                createPortal(
                    <div className={style.comp}>
                        <div className="mask"></div>
                        <div className={`body ${show ? 'show' : 'hide'}`}>
                            <div className="close" onClick={handleClose}>
                                {DialogClose}
                            </div>
                            <div className="name">{t('title')}</div>
                            <div className="text">{t('desc')}</div>
                            <EcoEmail
                                contactListId={[contactListIds[locale as keyof typeof contactListIds] ?? contactListIds.us]}
                                source="WEB_NEW_PRODUCT_SUB"
                                fields={fields}
                                termsHtml={termsHtml}
                                tipsObj={{
                                    placeholder: t('placeholder'),
                                    btnText: t('btnText'),
                                }}
                                needTerms
                            />
                        </div>
                    </div>,
                    document.body,
                )}
        </>
    );
};
export default Dialog;
